import { render, staticRenderFns } from "./shuguangdengta.vue?vue&type=template&id=3313501a&"
import script from "./shuguangdengta.vue?vue&type=script&lang=js&"
export * from "./shuguangdengta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports